import { createIcon } from './createIcon'

export const EllipsisMenuIcon = createIcon({
  displayName: 'EllipsisMenuIcon',
  viewBox: '0 0 24 24',
  path: [
    <circle cx="12" cy="5" r="1.5" fill="currentColor" key="dot1" />,
    <circle cx="12" cy="12" r="1.5" fill="currentColor" key="dot2" />,
    <circle cx="12" cy="19" r="1.5" fill="currentColor" key="dot3" />,
  ],
})
